import { updateItemInCollection } from "directus/src/operations";

export async function updateBookmark({ id, item }) {
    try {
        const query = {
            fields: [
                "id",
                "label",
                "url",
                "description",
                "bookmark",
            ],
        };

        const data = await updateItemInCollection("bookmark_links", id, item, query);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}